// extracted by mini-css-extract-plugin
module.exports = {"title":"Experience-module__title___1SDxd","timestamp":"Experience-module__timestamp___eFt3O"};